import React from 'react'
import Table from 'components/Table'
import { makeSitesColumns, makeSitesRows } from '../modalTable'
import { SitesTableWrapper } from './style'
import { useNavigate } from 'react-router-dom'
import { buildAboutUrl, editOnly } from 'routing/constants'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'

const AssessmentModal = ({ sites }) => {
  const history = useNavigate()

  const columns = makeSitesColumns()
  const rows = makeSitesRows(sites)

  const rowOnClick = (siteId, historyId, siteStatusId) => {
    const editOnlySite = siteStatusId === SITE_STATUS_EDIT_ONLY_ID || siteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null
    history(buildAboutUrl(siteId, historyId, editOnlySite))
  }

  return (
    <>
      <SitesTableWrapper>
        <Table
          columns={columns}
          rows={rows}
          noResultMessage='noReassessmentHistory'
          dataTest='sites-list'
          rowOnClick={rowOnClick}
        />
      </SitesTableWrapper>
    </>
  )
}

export default AssessmentModal
